package one.healthium.health_tools.ui

import androidx.compose.foundation.layout.Spacer
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.sp
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.DrawableResource

@Composable
internal fun LogControl(
    modifier: Modifier = Modifier.Companion,
    containerColor: Color,
    contentColor: Color,
    icon: DrawableResource,
    contentPrimary: String,
    contentSecondary: String,
    button: String? = null,
    onClick: () -> Unit = {},
) {
    BaseLogControl(
        modifier = modifier,
        containerColor = containerColor,
        icon = icon,
        button = button,
        onClick = onClick,
    ) {
        Text(
            text = contentPrimary,
            style = AppTheme.textStyles.secondary_17_500,
            color = contentColor,
            maxLines = 1,
            overflow = TextOverflow.Companion.Ellipsis,
            lineHeight = 20.sp,
        )
        Text(
            text = contentSecondary,
            style = AppTheme.textStyles.secondary_17_400,
            color = contentColor.copy(alpha = 0.3f),
            maxLines = 1,
            overflow = TextOverflow.Companion.Ellipsis,
            lineHeight = 20.sp,
        )
        Spacer(Modifier.Companion.weight(1f))
    }
}